<template>
  <div
    class="bg-white rounded-xl overflow-hidden shadow-md text-black p-5 h-full cursor-pointer w-full"
    @click="navigateTo('/formaciones/' + id)"
  >
    <div class="relative rounded-xl">
      <img :src="img" alt="" class="w-full h-48 object-cover rounded-xl" />
      <div
        class="absolute top-2 left-2 rounded-xl text-white text-xs font-bold px-2 py-1 star flex items-center gap-1"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M12.4252 19.4035L6.82733 23.6775C6.54996 23.9044 6.24737 24.0116 5.91957 23.999C5.59176 23.9864 5.30178 23.8918 5.04962 23.7153C4.79747 23.5388 4.60205 23.2993 4.46336 22.9967C4.32468 22.6941 4.31837 22.3663 4.44445 22.0133L6.60039 15.0159L1.11598 11.1201C0.813395 10.9184 0.624277 10.6536 0.54863 10.3258C0.472983 9.99801 0.485591 9.69542 0.586454 9.41805C0.687316 9.14068 0.863826 8.89482 1.11598 8.68049C1.36814 8.46616 1.67073 8.35899 2.02375 8.35899H8.79415L10.9879 1.09688C11.114 0.743862 11.3094 0.472794 11.5742 0.283676C11.8389 0.0945587 12.1226 0 12.4252 0C12.7278 0 13.0115 0.0945587 13.2762 0.283676C13.541 0.472794 13.7364 0.743862 13.8625 1.09688L16.0563 8.35899H22.8267C23.1797 8.35899 23.4823 8.46616 23.7344 8.68049C23.9866 8.89482 24.1631 9.14068 24.264 9.41805C24.3648 9.69542 24.3774 9.99801 24.3018 10.3258C24.2261 10.6536 24.037 10.9184 23.7344 11.1201L18.25 15.0159L20.406 22.0133C20.532 22.3663 20.5257 22.6941 20.387 22.9967C20.2484 23.2993 20.0529 23.5388 19.8008 23.7153C19.5486 23.8918 19.2586 23.9864 18.9308 23.999C18.603 24.0116 18.3005 23.9044 18.0231 23.6775L12.4252 19.4035Z"
            fill="#F2CB05"
          />
        </svg>
        {{ rating }}
      </div>
    </div>
    <div class="p-4 pb-0">
      <h3 class="font-bold mb-1 text-[#343434] font-poppins uppercase">
        {{ title }}
      </h3>
      <p class="text-[#4D617C] text-sm font-poppins">{{ desc }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  id: string;
  title: string;
  desc: string;
  rating: string;
  img: string;
}>();
</script>
<style scoped>
.star {
  border-radius: 32px;
  background: var(--Glass-Grey, rgba(194, 194, 194, 0.5));
  box-shadow: 0 5px 5px 0 rgba(49, 49, 49, 0.1);
  backdrop-filter: blur(8px);
}
</style>
